/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 1000
// module chunks = 7